import {combineReducers} from "redux";
import {authReducer} from "./auth";
import {dashboardReducer} from "./dashboard";
import {usersReducer} from "./usersReudcer";
import {referencesReducer} from './referencesReudcer';
import {cpManagersReducer} from "./cpManagersReudcer";
import {cpServicesReducer} from "./cpServicesReudcer";
import {labelsReducer} from "./labelsReudcer";
import {servicesReducer} from "./servicesReudcer";
import {reportReducer} from "./reportReducer";
import {contentReducer} from "./contentReducer";
import {territoryReducer} from './territoryReducer';
import {confirmationReducer} from './confirmationReducer';
import {helpReducer} from './helpReducer';
import {invoicesReducer} from './invoicesReudcer';

export const rootReducer = combineReducers({
  authReducer, dashboardReducer, usersReducer, referencesReducer, cpManagersReducer, cpServicesReducer,
  labelsReducer, contentReducer, servicesReducer, reportReducer, territoryReducer, confirmationReducer, helpReducer,
  invoicesReducer,
});
